import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'
import { BUILDING_TITLES } from 'helpers/i18n'

import { MODERNIZATION_ANIMATION_TIMEOUT } from 'constants'

import SOUNDS from 'sounds'

export const BUILDING_UPGRADE_REQUEST = 'building_upgrade/REQUEST'
export const BUILDING_UPGRADE_SUCCESS = 'building_upgrade/SUCCESS'
export const BUILDING_UPGRADE_ERROR = 'building_upgrade/ERROR'
export const BUILDING_UPGRADE_SHOW_HIGHLIGHT = 'building_upgrade/SHOW_HIGHLIGHT'
export const BUILDING_UPGRADE_HIDE_HIGHLIGHT = 'building_upgrade/HIDE_HIGHLIGHT'
export const BUILDING_UPGRADE_CONFIRMATION_OPEN = 'building_upgrade/OPEN_CONFIRMATION'
export const BUILDING_UPGRADE_CONFIRMATION_CLOSE = 'building_upgrade/CLOSE_CONFIRMATION'

let animationTimeout

export function startUpgradeRequest() {
    return {
        type: BUILDING_UPGRADE_REQUEST,
        payload: {},
    }
}

export function upgradeSubmitSuccess(resp, locale) {
    const { building, industrial_resource_balance } = resp
    const buildingTitleLocalizationId = BUILDING_TITLES[resp.building.type].props.id

    return {
        type: BUILDING_UPGRADE_SUCCESS,
        meta: {
            webToClient: {
                handler: 'buildingUpgraded',
                params: {
                    buildingName: locale.messages[buildingTitleLocalizationId],
                    buildingLevel: resp.building.level,
                },
            },
        },
        payload: {
            building,
            industrialResourceBalance: industrial_resource_balance,
        },
    }
}

export function upgradeSubmitError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: BUILDING_UPGRADE_ERROR,
        payload: errorData,
    }
}

export function showUpgradeHighlight() {
    return {
        type: BUILDING_UPGRADE_SHOW_HIGHLIGHT,
        payload: {},
        meta: {
            webToClient: {
                handler: 'playSound',
                params: {
                    soundId: SOUNDS.MODERNIZATION_HOVER,
                },
            },
        },
    }
}

export function hideUpgradeHighlight() {
    return {
        type: BUILDING_UPGRADE_HIDE_HIGHLIGHT,
        payload: {},
    }
}

export function openUpgradeConfirmation() {
    return {
        type: BUILDING_UPGRADE_CONFIRMATION_OPEN,
        payload: {},
        meta: {
            webToClient: {
                handler: 'playSound',
                params: {
                    soundId: SOUNDS.MODERNIZATION_CLICK,
                },
            },
        },
    }
}

export function closeUpgradeConfirmation() {
    clearTimeout(animationTimeout)
    return {
        type: BUILDING_UPGRADE_CONFIRMATION_CLOSE,
        payload: {},
    }
}

export default function upgradeBuilding(buildingId, nextLevel) {
    return async (dispatch, getState) => {
        const { buildingUpgrade, locale } = getState()
        if (buildingUpgrade.submitting) {
            return
        }
        dispatch(startUpgradeRequest())

        const url = `/game_api/buildings/${buildingId}`
        httpRequest(url, 'PATCH', { level: nextLevel }).then(
            resp => {
                animationTimeout = setTimeout(dispatch.bind(null, closeUpgradeConfirmation()),
                    MODERNIZATION_ANIMATION_TIMEOUT)
                return dispatch(upgradeSubmitSuccess(resp, locale))
            },
            errorData => dispatch(upgradeSubmitError(errorData))
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/building_upgrade.js